import { useMemo } from "react";
import Chart from "react-apexcharts";
import { normalizeTimelineForChart } from "../LinkHelper";

export const AnalyticsChart = (
    {
        timeline = [],
        range = "all-time",
        showPageViews = true,
        showServiceClicks = true }
) => {
    const { labels, clicks, streams } = normalizeTimelineForChart(timeline, range);
    
    const chartOptions = {
        chart: {
            id: "activity-chart",
            type: "area",
            height: 350,
            stacked: false,
            zoom: { enabled: false }
        },
        stroke: {
            curve: "smooth",
            width: 2
        },
        fill: {
            type: "gradient",
            gradient: {
                opacityFrom: 0.45,
                opacityTo: 0.15
            }
        },
        markers: {
            size: 4
        },
        // xaxis: {
        //     categories: dates
        // },
        xaxis: {
            categories: labels,
            labels: {
                rotate: -45,
                style: { colors: "#00067e", fontSize: "12px" }
            }
        },
        yaxis: {
            min: 0
        },
        legend: {
            position: "bottom"
        },
        tooltip: {
            shared: true,
            intersect: false
        }
    };

    // NO useState here
    const chartSeries = [];

    if (showPageViews) {
        chartSeries.push({
            name: "Page Views",
            data: clicks,
            color: "#00067e"
        });
    }

    if (showServiceClicks) {
        chartSeries.push({
            name: "Click to Service",
            data: streams,
            color: "#fa6138"
        });
    }

    return (
        <Chart
            options={chartOptions}
            series={chartSeries}
            type="area"
            height={350}
        />
    )
}
